import {
  breakpoints,
  customScrollMinimal,
  Drawer,
  fontWeight,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  ${Drawer.Styled.Container},${Drawer.Styled.BackgroundOverlay} {
    z-index: 2;
  }
`;

export const DrawerText = styled.div`
  ${typographyV2.bodySm}
  color: var(--text-soft);
  padding: 16px;
`;

export const Container = styled.section`
  overflow-x: auto;
  overscroll-behavior-x: contain;
  ${customScrollMinimal}
  padding: 0;
  @media ${breakpoints.sm} {
    padding: 16px;
  }
`;

export const Strong = styled.strong`
  ${fontWeight.medium}
`;
